import client from '../client'

const PATH = '/brands'

/**
 * Get all the distinct brands present in the given classification.
 * @param {Number} classificationId
 */
function getByClassificationId(classificationId) {
  return client.get(PATH, { params: { classificationId } }).then(({ data }) => data)
}

export default {
  getByClassificationId
}